import { render, staticRenderFns } from "./lkuCustomerWholesale.vue?vue&type=template&id=91ffe4ca"
import script from "./lkuCustomerWholesale.vue?vue&type=script&lang=js"
export * from "./lkuCustomerWholesale.vue?vue&type=script&lang=js"
import style0 from "./lkuCustomerWholesale.vue?vue&type=style&index=0&id=91ffe4ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports